<template>
  <div>
    <Breadcrumbs />
    <div class="wrapper mt-5 mb-5 pb-5 successpage">
      <div class="container order-successpage">
        <h1 class="mb-4 text-black">{{ $t("order_thank_you") }}</h1>
        <p class="page-tagline border-bottom border-black border-2 fs-5 pb-4 order-number">
          {{ $t("success_order_number") }}: {{ "#" + orderId  }}
        </p>
        <b-link to="/" class="btn btn-secondary btn-big mx-auto mx-lg-0 successpage_back">
          {{ $t("continue_shopping") }}</b-link
        >
        <form class="cart-details my-5" v-if="ordersList.length > 0">
          <div class="cart-heading border-bottom border-black py-3 py-md-4">
            <div class="cart-heading-items">
              <h4 class="mb-0">{{ $t("your_order_overview") }}</h4>
            </div>
          </div>
          <div
            class="cart-items"
            v-for="orderItem of ordersList"
            :key="orderItem.id"
          >
            <div
              class="cart-item border-bottom border-black d-flex py-5"
              v-for="order of orderItem.items"
              :key="order.id"
            >
              <a
                class="cart-item-image align-self-start border border-secondary"
                href="#"
              >
                <img
                  class="img-fluid"
                  :src="order.image.url"
                  alt="Hemd-52 Blauw Slim Fit Opstaande"
                  width="215"
                  height="180"
                />
              </a>
              <div class="cart-item-details ms-3 ms-md-5 w-100 me-lg-3 pe-lg-5">
                <h5 class="cart-item-name mb-4">
                  <a href="#">{{ order.product_name }}</a>
                </h5>
                <div
                  class="cart-item-meta d-flex flex-column flex-md-row justify-content-between align-items-stretch w-100"
                >
                  <div
                    class="cart-item-meta-size d-flex flex-column justify-content-between"
                  >
                    <div v-if="typeof order.selected_options != 'undefined'">

                    <div class="cart-item-product-detail">
                        <div
                          class="cart-item-size text-uppercase"
                          v-for="(option, index) of order.selected_options"
                          :key="index"
                        >
                          {{ option.label }}: {{ option.value }}
                        </div>
                        <div
                          class="cart-item-price fs-2 fw-bold text-primary order-1 order-lg-2 cartitem-responsive"
                        >
                          {{
                            formatCurrency(
                              order.product_sale_price.value *
                                order.quantity_ordered
                            )
                          }}
                        </div>
                      </div>
                      <div class="cart-item-product-qty">
                        <div class="cart-item-qty cartitem-responsive order-2 order-lg-1">
                          <input
                            type="text"
                            class="form-control "
                            placeholder="Qty"
                            aria-label="Product Quantity"
                            :value="order.quantity_ordered"
                            disabled
                          />
                        </div>
                      </div>

                    </div>
                    <div v-if="order.bundle_options !== undefined">
                      <ul>
                        <li
                          v-for="option of order.bundle_options"
                          :key="option.id"
                        >
                          <span>{{ option.label }}</span>
                          <div v-if="option.values">
                            <div
                              class="sub"
                              v-for="val of option.values"
                              :key="val.label"
                            >
                              <span>
                                - {{ val.quantity }}X{{ val.label }}
                              </span>
                              <span>
                                {{ formatCurrency(val.price) }}
                              </span>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    class="cart-item-meta-qty-price d-flex flex-column flex-lg-row justify-content-between align-items-start"
                  >
                    <div class="cart-item-qty cartitem-desktop order-2 order-lg-1">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Qty"
                          aria-label="Product Quantity"
                          :value="order.quantity_ordered"
                          disabled
                        />
                      </div>
                    </div>
                    <div
                      class="cart-item-price cartitem-desktop fs-2 fw-bold text-primary order-1 order-lg-2"
                    >
                      {{
                        formatCurrency(
                          order.product_sale_price.value *
                            order.quantity_ordered
                        )
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cart-discount-total row mt-5 mt-md-0 pt-md-5">
            <div class="col-12 col-md-5 cart-total pt-0">
              <h3 class="border-bottom border-black mb-4 pb-4 text-black">
                {{ $t("totals") }}
              </h3>
              <table class="table table-borderless fw-bold">
                <tr class="text-black">
                  <td>{{ $t("subtotal_btw") }}:</td>
                  <td>
                    {{ formatCurrency(ordersList[0].total.subtotal.value) }}
                  </td>
                </tr>
                <tr class="text-black">
                  <td>{{ $t("shipping_cost") }}:</td>
                  <td>
                    {{
                      formatCurrency(ordersList[0].total.total_shipping.value)
                    }}
                  </td>
                </tr>
                <tr class="text-black">
                  <td>BTW:</td>
                  <td>
                    {{ formatCurrency(ordersList[0].total.total_tax.value) }}
                  </td>
                </tr>
                <tr class="total-row">
                  <td class="text-black">{{ $t("total_btw") }}:</td>
                  <td class="text-primary row-total">
                    {{ formatCurrency(ordersList[0].total.grand_total.value) }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </form>
        <div
          class="offers my-5 pt-5"
          v-if="inActionProducts && inActionProducts.length > 0"
        >
          <h2 class="section-heading" style="line-height: 1.6 !important">
            <span>{{ $t("order_success_more_product") }}</span>
          </h2>
          <ClientOnly>
            <div class="product-grid">
              <div class="swiper">
                <div
                  class="grid-row row row-cols-2 row-cols-lg-3 row-cols-xl-4 swiper-wrapper"
                >
                  <div
                    class="col swiper-slide"
                    v-for="(product, index) of inActionProducts"
                    :key="`prod` + index"
                  >
                    <ProductCardWithPagination
                      :product="product"
                      v-if="product != null"
                    />
                  </div>
                </div>
              </div>
              <div
                class="swiper-button-prev swiper-nav-round offers-swiper-button-prev"
              ></div>
              <div
                class="swiper-button-next swiper-nav-round offers-swiper-button-next"
              ></div>
              <div
                class="d-flex justify-content-between align-items-center my-3 my-md-5 d-lg-none"
              >
                <p class="fs-6 mb-0">
                  {{ $t("articles") }} {{ paginationConf.currentPageNr }}
                  {{ $t("to") }} {{ Math.ceil(rows / paginationConf.perPage) }}
                  {{ $t("by") }} {{ rows }} in {{ $t("total") }}
                </p>
                <b-pagination
                  v-model="paginationConf.currentPageNr"
                  :total-rows="rows"
                  :per-page="paginationConf.perPage"
                  @change="tmp"
                  class="cst-pagination ms-4 mt-3"
                  aria-controls="cat-item"
                  align="right"
                  :hide-goto-end-buttons="true"
                >
                  <template #page="{ page }">
                    <b-link class="page-link">
                      {{ page }}
                    </b-link>
                  </template>
                </b-pagination>
              </div>
            </div>
          </ClientOnly>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderInfoFromHash } from "@storefront/core/data-resolver/cart";
import config from "@storefront/core/lib/utils/config";
import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs.vue";
import ProductCardWithPagination from "@/esf_antarctica_lederhosenland/core/components/category-product/ProductCardWithPagination.vue";
import { isMobile } from "mobile-device-detect";

export default {
  name: "PaymentSuccess",
  components: {
    Breadcrumbs,
    ProductCardWithPagination,
  },
  metaInfo() {
    return {
      meta: [
        { name: "title", content: this.$t("payment_success") },
        { name: "keywords", content: this.$t("payment_success") },
        { name: "description", content: this.$t("payment_success") },
      ],
      title: this.$t("payment_success"),
    };
  },
  created() {
    this.$store.dispatch("user/loadOrders");
  },
  methods: {
    formatCurrency(value) {
      var formatter = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      });
      return formatter.format(value);
    },
    tmp(id) {
      this.showOrders = false;
      setTimeout(() => {
        this.showOrders = true;
        this.paginationConf.currentPageNr = id;
      }, 0.001);
    },
  },
  computed: {
    transactionId() {
      if (typeof this.$store.state.route.query.transactionid != "undefined") {
        return this.$store.state.route.query.transactionid;
      }
      return null;
    },
    isLoggedIn() {
      return this.$store.getters["user/getIsLoggedIn"];
    },
    showCustomerEmail() {
      if (config.showCustomerEmail !== undefined) {
        return config.showCustomerEmail;
      } else {
        return false;
      }
    },
    inActionProducts() {
      const items = this.$store.getters["home/getInActionProducts"];
      if (items.length === 0) {
        return [];
      }
      if (isMobile) {
        return items.slice(
          (this.paginationConf.currentPageNr - 1) * this.paginationConf.perPage,
          this.paginationConf.currentPageNr * this.paginationConf.perPage
        );
      } else {
        return items;
      }
    },
    rows() {
      return this.$store.getters["home/getInActionProducts"].length;
    },
  },
  async mounted() {
    const hashId = localStorage.getItem("orderHash");
    if (hashId) {
      const order = await getOrderInfoFromHash(hashId);
      this.ordersList.push(order);
      const bcrumb = { current: "success", routes: [] };
      this.$store.commit("breadcrumbs/set", bcrumb);
      if (order) {
        this.orderId = order.number;
        if (this.$gtm.enabled() == true) {
          if (order != false) {
            const items = [];
            const prods = [];
            order.items.forEach((element) => {
              let item = {};
              let prod = {};
              item.id = element.product_sku;
              item.name = element.product_name;
              item.price = element.product_sale_price.value;
              item.quantity = element.quantity_ordered;
              prod.item_id = element.product_sku;
              prod.item_name = element.product_name;
              prod.price = element.product_sale_price.value;
              prod.quantity = element.quantity_ordered;
              items.push(item);
              prods.push(prod);
            });
            if (!this.$gtm.uaDisabled) {
              //GA event
              window.dataLayer.push({
                event: "purchase",
                ecommerce: {
                  currencyCode: "EUR",
                  purchase: {
                    actionField: {
                      id: this.orderId,
                      affiliation: config.app_name,
                      revenue: order.total.subtotal.value,
                      tax: order.total.total_tax.value,
                      shipping: order.total.total_shipping.value,
                    },
                    products: items,
                  },
                },
                email: this.showCustomerEmail ? order.customer_email : "",
              });
            }
            if (this.$gtm.ga4Enabled) {
              //GA4 event
              window.dataLayer.push({
                event: "purchase",
                ecommerce: {
                  add: {
                    transaction_id: this.orderId,
                    affiliation: config.app_name,
                    value: order.total.subtotal.value,
                    tax: order.total.total_tax.value,
                    shipping: order.total.total_shipping.value,
                    items: prods,
                  },
                },
                email: this.showCustomerEmail ? order.customer_email : "",
              });
            }
          }
        }
      }
    }
  },
  data() {
    return {
      showOrders: true,
      ordersList: [],
      paginationConf: {
        currentPageNr: 1,
        totalCount: 0,
        perPage: 4,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
